// extracted by mini-css-extract-plugin
export default {"PageHeader":"header-module--PageHeader---aDld","SiteTitle":"header-module--SiteTitle--jW4Ro","Title":"header-module--Title--1X88p","SidePanel":"header-module--SidePanel--FjvDO"};